module.exports = __webpack_public_path__ + "assets/about_function_07.f0defff5.svg";